import Vue from "vue";
import Vuex, { StoreOptions, ExModule } from "vuex";
import { RootState } from "./types";
import common from "./common";
import serviceDomain from "./domains/service";
import todoDomain from "./domains/todo";
import userDomain from "./domains/user";
import planDomain from "./domains/plan";
import plansDomain from "./domains/plans";
import eventExperiencesDomain from "./domains/eventExperiences";
import eventExperienceDomain from "./domains/eventExperience";
import eventDetailDomain from "./domains/eventDetail";
import reports from "./domains/reports";
import report from "./domains/report";
import notificationsDomain from "./domains/notifications";
import notificationSettingDomain from "./domains/notificationSetting";
import clipsDomain from "./domains/clips";
import FilesDomain from "./domains/files";
import plansPage from "./pages/plans";
import planPage from "./pages/plan";
import performancesPage from "./pages/performances";

Vue.use(Vuex);

const domains: ExModule<RootState> = {
  namespaced: true,
  modules: {
    service: serviceDomain,
    todo: todoDomain,
    user: userDomain,
    plan: planDomain,
    plans: plansDomain,
    eventExperiences: eventExperiencesDomain,
    eventExperience: eventExperienceDomain,
    eventDetail: eventDetailDomain,
    reports: reports,
    report: report,
    notifications: notificationsDomain,
    notificationSetting: notificationSettingDomain,
    clips: clipsDomain,
    files: FilesDomain
  }
};

const pages: ExModule<RootState> = {
  namespaced: true,
  modules: {
    plans: plansPage,
    plan: planPage,
    performances: performancesPage
  }
};

export const store: StoreOptions<RootState> = {
  modules: {
    common,
    domains,
    pages
  }
};

const storeInstance = new Vuex.Store<RootState>(store);

export default storeInstance;

export const useStore = () => storeInstance;
